"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscribe = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _NewsletterDialog = require("./components/NewsletterDialog/NewsletterDialog");
var _components = require("./components/NewsletterDialog/components");
var _types = require("./components/NewsletterDialog/types");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Subscribe = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    newsletterSubsciptionConfiguration,
    isMobileOffice
  } = (0, _hooks.useFooter)();
  const {
    footer,
    popup
  } = newsletterSubsciptionConfiguration ?? {};
  const {
    onClose,
    onOpen,
    open
  } = (0, _presentationHooks.useDisclose)();
  const [origin, setOrigin] = (0, _react.useState)(_types.Origin.OnlinePopup);
  (0, _hooks.useSubscribePopup)({
    open,
    onOpen,
    footer,
    popup
  });
  const openDialog = (0, _react.useCallback)(() => {
    _jsCookie.default.set(_constants.newsletterPopupCookieKey, _constants.newsletterPopupCookieValue, {
      expires: popup?.displayFrequencyInDays ?? _constants.cookieExpireDays
    });
    setOrigin(_types.Origin.OnlineFooter);
    onOpen();
  }, [popup?.displayFrequencyInDays, onOpen]);
  if (!footer?.enabled) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      "data-testid": getTestId(_constants2.SUBSCRIBE),
      role: "button",
      tabIndex: 0,
      isMobileOfficeFull: isMobileOffice,
      onClick: openDialog,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconRoot, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Send, {
          fontSize: "inherit"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "subtitle1",
        component: "h6",
        align: "center",
        fontWeight: "bold",
        children: footer.title
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.NewsletterDialogContextProvider, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewsletterDialog.NewsletterDialog, {
        open: open,
        origin: origin,
        onClose: onClose
      })
    })]
  });
};
exports.Subscribe = Subscribe;
